import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp12};
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`
